export default {
  login: {
    title: 'Entrar',
    subtitle: 'Acesse o painel LOCZI',
    email: 'E-mail',
    password: 'Senha',
    submit: 'Entrar',
    forgot: 'Esqueci a senha',
    remember: 'Manter conectado',
    google: 'Entrar com Google',
    or: 'ou',
    no_account: 'Não tem conta?',
    create_account: 'Criar conta',
    invalid: 'Credenciais não conferem.',
  },
  logout: 'Sair',
  register: {
    title: 'Criar conta',
    name: 'Nome completo',
    email: 'E-mail',
    password: 'Senha',
    password_confirmation: 'Confirmar senha',
    submit: 'Cadastrar',
    have_account: 'Já tem conta? Entrar',
  },
  select_account: {
    title: 'Escolha a conta',
    empty_title: 'Nenhuma conta disponível',
    empty_body: 'Peça um convite ao administrador da sua conta ou finalize uma compra no site.',
  },
  shell: {
    tagline_a: 'Tudo que importa.',
    tagline_b: 'Vistas agora',
    demo_key: 'Chaves de casa',
    demo_place: 'Rua das Flores, 280',
    demo_status: 'Mais fácil de encontrar.',
  },
  forgot: {
    title: 'Perdeu o acesso.',
    title_extra: 'Não a conta.',
    subtitle: 'Informe seu e-mail e enviamos um código de 6 dígitos para criar uma nova senha.',
    email_label: 'E-mail',
    submit: 'Enviar código por e-mail',
    back_to_login: 'Voltar para o login',
    sent_title: 'Código no e-mail.',
    sent_body: 'Se o e-mail existir, o código chega em instantes.',
  },
  reset: {
    title: 'Código no e-mail.',
    title_extra: 'Acesso em segundos.',
    sent_to: 'Digite o código de 6 dígitos enviado para {email}.',
    code: 'Código',
    code_hint: 'Código de 6 dígitos enviado por e-mail',
    new_password: 'Nova senha',
    confirm_password: 'Confirmar senha',
    submit: 'Redefinir senha',
    resend: 'Não recebeu? Reenviar código',
    resent: 'Código reenviado.',
    min_chars: 'Mínimo de 8 caracteres.',
    success_title: 'Senha redefinida.',
    success_body: 'Sua conta está segura de novo. Entre com a nova senha.',
    incomplete_link: 'Link incompleto.',
    incomplete_body: 'Esta página de redefinição veio sem o e-mail. Peça um novo código para continuar.',
    ask_new: 'Pedir novo código',
    go_login: 'Ir para o login',
    back_to_login: 'Voltar para o login',
  },
  invite: {
    welcome: 'Bem-vindo(a)!',
    joined: 'Você entrou na conta {account}. Abrindo o mapa…',
    accept_failed: 'Não foi possível aceitar o convite.',
    not_found: 'Convite não encontrado.',
    expired: 'Convite expirado ou revogado',
    expired_body: 'Peça um novo convite ao responsável pela conta.',
    go_map: 'Ir para o mapa',
    invite_for: 'Convite para {account}',
    invited_as: 'Você foi convidado como {role}',
    email_mismatch: 'Este convite foi emitido para {invited}, mas você está logado como {current}. Saia e entre com o e-mail convidado.',
    accept_hint: 'Ao aceitar, a conta passa a aparecer na sua lista de empresas.',
    accept: 'Aceitar convite',
  },
}
